import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    delete: 'Delete',
    edit: 'Edit',
  },
  fr: {
    delete: 'Supprimer',
    edit: 'Modifier',
  },
});

export default locales;
